import styled from 'styled-components';

export const StyledUsersList = styled.div`
  font-family: 'Poppins', sans-serif;
  background-color: #FFFFFF;
  box-shadow: 0 3px 4px rgba(0, 0, 0, .5);
  padding: 25px;
  margin: 30px;
  border-radius: 4px;
  font-size: 1.5em;
  color: #2B2932;
  
  .fa.fa-bullhorn {
    color: #F3463C;
    margin-right: 10px;
  }
  
  table {
    margin: 0;
    
    thead tr th {
      border: 0;
      color: #B2B2B2;
      font-size: 12px;
    }
    
    tr td {
      vertical-align: middle;
      color: #8D8D8D;
    }
  }
  
  form {
    margin: 20px 0;
    
    label {
      margin: 0;
    }
    
    input {
      padding: 5px 15px;
      color: #2B2932;
      border: 1px solid #B7B7B7;
    }
  }
`;
